import angular from 'angular';
import { utilityService } from 'app/services';
import controller from './training-presentation.controller';
import directive from './training-presentation.directive';


export default angular.module('app.components.support.trainingPresentation', [
  utilityService
])
  .directive('trainingPresentation', directive)
  .controller('TrainingPresentationController', controller)
  .name;

console.log('app.components.support.trainingPresentation created');
